import React from 'react';
import './style.css';


const Footer = () => {
    return (
        <div className="footer">
            <div>Made by <a href="https://github.com/antontim4enko/shopping-cart">Den4ik</a></div>
        </div>
    );
};

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer/index.js